export default __webpack_public_path__ + "static/media/step-arrow.8325307b.svg";